// ======================================================================
// File Name       : ReservedEmailList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Table, Col, Form } from 'react-bootstrap';
import ReduxFormPaging from '../ReduxFormPaging';
import * as ICON from '../../constants/IconConstants';
import { RESERVED_EMAIL_DETAIL } from '../../constants/PathConstants';
import CustomLink from '../button/CustomLink';

const thead = [
  { title: '件名', sortBy: 0 },
  { title: '予約日時', sortBy: 1},
  { title: '操作', sortBy: null, width: 100 },
];

class ReservedEmailList extends React.Component {
  render() {
    const { reservedEmailList, handleSortState, invalid, goToDetail, recordNum, getStartEndData } = this.props;
    let tbody;
    if (reservedEmailList && reservedEmailList.length) {
      tbody = reservedEmailList.map((mail, index) => {
        const {
          reservedEmailTitle,
          reservedDate,
        } = mail;
        const link = RESERVED_EMAIL_DETAIL.replace(':id', mail.emailSenderIdAuto);
        return (
          <tr key={index} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>
              {reservedEmailTitle}
            </td>
            <td>
              {reservedDate}
            </td>
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail-edit"
                to={link}
                text="詳細"
              />
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="reservedEmailSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>
            {tbody}
          </tbody>
        </Table>
        <Form.Group>
          <Col sm={12} className="text-center">
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
            />
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default ReservedEmailList;
